/** 轮播接口轮询间隔（ms） */
const CAROUSEL_POLL_MS = 30000

/**
 * 轮播数据轮询 mixin
 * 组件需实现 loadCarouselNotices 方法
 */
export default {
  data() {
    return {
      carouselPollTimer: null,
    }
  },
  beforeDestroy() {
    this.stopCarouselPoll()
  },
  methods: {
    startCarouselPoll() {
      this.stopCarouselPoll()
      if (typeof this.loadCarouselNotices !== 'function') return
      this.loadCarouselNotices()
      this.carouselPollTimer = setInterval(() => {
        this.loadCarouselNotices()
      }, CAROUSEL_POLL_MS)
    },
    stopCarouselPoll() {
      if (this.carouselPollTimer) {
        clearInterval(this.carouselPollTimer)
        this.carouselPollTimer = null
      }
    },
  },
}
